export default "__VITE_ASSET__577b4c10__"